export default {
  SERVICE_STATUS: {
    processed: 'PROCESSED',
    processing: 'PROCESSING',
  },
}
